import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';

import { EXPERIMENTS, LOCALES } from '../constants';

const useIsKbServiceEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const { locale } = useRouter();
  // Opened to English users first — see isKbServiceEnabled in utils/experiments.
  return (
    experiments.enabled(EXPERIMENTS.SPECS.ARTICLE_FROM_KB_SERVICE) &&
    locale === LOCALES.EN
  );
};

export default useIsKbServiceEnabled;
